import { apiClient } from "@/services/apiClient";

export interface SubscriptionInvoiceRow {
  chargeId: string;
  chargedAt: string;
  planId: string;
  planName: string;
  billingInterval: "monthly" | "annual";
  subtotalMinor: number;
  taxMinor: number;
  amountMinor: number;
  currency: string;
  invoiceStatus: "pending_invoice" | "invoice_issued" | "invoice_failed";
  lastError: string | null;
  invoice: {
    id: string;
    series: string;
    number: number | null;
    dgiStatus: string;
    status: string;
  } | null;
}

export function listSubscriptionInvoices(): Promise<SubscriptionInvoiceRow[]> {
  return apiClient
    .get<SubscriptionInvoiceRow[]>("/tenants/current/subscription-invoices")
    .then((res) => res.data);
}

export function downloadSubscriptionInvoicePdf(
  chargeId: string,
): Promise<void> {
  return apiClient
    .get<Blob>(`/tenants/current/subscription-invoices/${encodeURIComponent(chargeId)}/pdf`, {
      responseType: "blob",
    })
    .then((res) => {
      const blob = res.data;
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `fiscalo-${chargeId}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    });
}
